import { render, staticRenderFns } from "./jobIdx.vue?vue&type=template&id=0167673c&scoped=true"
import script from "./jobIdx.vue?vue&type=script&lang=js"
export * from "./jobIdx.vue?vue&type=script&lang=js"
import style0 from "./jobIdx.vue?vue&type=style&index=0&id=0167673c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0167673c",
  null
  
)

export default component.exports